// Route paths for the group customer/supplier mapping views. Mirror routes/routeConfig.tsx.
export const MAPPING_MATRIX_ROUTE = '/settings/company/group/customer-mapping'
export const MAPPING_PAIR_ROUTE = `${MAPPING_MATRIX_ROUTE}/pair`
export const MAPPING_WIZARD_ROUTE = `${MAPPING_MATRIX_ROUTE}/wizard`
